import QuickFetch from 'quickfetch';
import { getCookie } from '../../NormalHelper';
import { AppCodeConstant } from '../../Constants';

export default function useHeadersMiddleware(r) {
  // headers
  r.use(QuickFetch.REQUEST, (req, next) => {
    req.headers.set('cookies', getCookie()); // 兼容之前的写法 🐶

    req.headers.set('x-appcode', btoa(AppCodeConstant.AIDC));
    
    // console.log(req.headers.get('Content-Type'), r._args)
    const hasHeader = r._args[2] 
      && r._args[2].headers 
      && r._args[2].headers['Content-Type'];
    
    const needBody = !/^(get|head|delete)$/i.test(req.method);

    if (!hasHeader && needBody) { // 兼容之前的 emulateJSON: true
      req.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    } else {
      req.headers.set('Content-Type', 'application/json;charset=utf-8');
    }
    // console.log(555, req.headers.get('Content-Type'));
    next(req);
  });
}



// WEBPACK FOOTER //
// ./src/common/fetchWrapper/middlewares/headers.js